import axiosClient from './axiosClient';

export default {
  // Lista stanze/chat per l'utente loggato
  listRooms: () => axiosClient.get('/chat/rooms'),

  get: (roomId) => axiosClient.get(`/chat/${roomId}`),

  getFascicoloRoom: (fascicoloId) =>
    axiosClient.get(`/chat/fascicolo/${fascicoloId}`),
  // Recupera i messaggi di una stanza specifica
  getMessages: (roomId, params) => axiosClient.get(`/chat/${roomId}/messages`, { params }),
downloadAttachment: (attachmentId) =>
  axiosClient.get(`/chat/attachments/${attachmentId}`, {
    responseType: 'blob' // <-- essenziale per file binari
  }),
  // Invia un nuovo messaggio a una stanza
  sendMessage: (roomId, formData) =>
  axiosClient.post(`/chat/${roomId}/message`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  // (Opzionale) crea una stanza - se la logica lo prevede
  createRoom: (formData) => axiosClient.post('/chat/createroom', formData),

  // (Opzionale) elimina una stanza - se l'utente/ADMIN ha i permessi
  deleteRoom: (roomId) => axiosClient.delete(`/chat/rooms/${roomId}`),

  // (Opzionale) allega file a un messaggio
  attachFile: (roomId, formData) =>
      axiosClient.post(`/chat/${roomId}/attachments`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      }),
};
